<template>
  <div
    v-if="isAvailableForBooking"
    class="offer-booking-footer tw-flex tw-justify-center tw-bg-bg-primary tw-py-6 tw-bottom-0"
  >
    <div class="tw-flex tw-gap-x-4 tw-w-full tw-max-w-[560px]">
      <div
        v-if="!offer.proposal && (!proposal || (proposal && !proposal.uuid))"
        class="tw-flex-1"
      >
        <ui-button
          :rounded="false"
          class="tw-px-4 tw-w-full"
          size="lg"
          variant="info"
          outline
          data-test="new-proposal"
          @click="toggleProposalModal({ toggleValue: true })"
        >
          {{ $t("offer.proposals.new_proposal") }}
        </ui-button>
      </div>
      <div class="tw-flex-1">
        <ui-button
          class="tw-px-4 tw-w-full"
          variant="primary"
          size="lg"
          data-test="book-offer"
          @click="book"
        >
          {{ $t("booking_offer_title") }}
        </ui-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, defineComponent, toRefs } from '@vue/composition-api'

  import useMatomo from '@/composables/useMatomo'
  import { EventBus } from '@/services/EventBus'

  export default defineComponent({
    props: {
      offer: {
        type: Object,
        required: true
      },
      proposal: {
        type: Object,
        default: null
      }
    },
    setup (props) {
      const { offer } = toRefs(props)
      const matomo = useMatomo()

      const isAvailableForBooking = computed(() => {
        if (typeof offer.value.available_for_booking === 'undefined') return true
        if (offer.value.available_for_booking) return true

        return false
      })

      function book () {
        if (matomo) {
          matomo.trackEvent('Offers', 'Initiated Booking', offer.value.uuid)
        }

        EventBus.$emit('toggle-booking-modal')
      }

      // @ts-ignore
      function toggleProposalModal ({ renew, toggleValue }) {
        if (toggleValue && matomo) {
          matomo.trackEvent('Offers', 'Initiated Proposal', offer.value.uuid)
        }

        EventBus.$emit('toggle-proposal-modal', renew)
      }

      return {
        book,
        isAvailableForBooking,
        toggleProposalModal
      }
    }
  })
</script>

<style lang="scss" scoped>
  .offer-booking-footer {
    border-top: 1px solid $gray;
  }
</style>
